import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class WaitingService {

  private count: number = 0;

  constructor(private spinner: NgxSpinnerService) { }

  show() {
    this.spinner.show();
    this.count++;
  }

  hide() {
    this.count--;
    if (this.count == 0) {
      this.spinner.hide();
    }
  }
}
